import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_DETAILS, AUTH_TOKEN, MENU_ITEMS } from 'constants/AuthConstant';
import { useDispatch } from 'react-redux';
import masterService from 'services/MasterService';



export const initialState = {
    loading: false,
    message: '',
    list: null,
    sublist: null,
    subloading: false
}

export const roleListAll = createAsyncThunk('/role/list', async (data, { rejectWithValue }) => {

    try {
        const response = await masterService.getRole(data)
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const roleSubListAll = createAsyncThunk('/role/subList', async (data, { rejectWithValue }) => {

    try {
        const response = await masterService.getDepartment(data)
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})




export const roleSlice = createSlice({
    name: 'role',
    initialState,
    reducers: {

        roleList: (state, action) => {
            state.loading = true
            state.list = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(roleListAll.pending, (state) => {

                state.loading = false
            })
            .addCase(roleListAll.fulfilled, (state, action) => {
                state.loading = true
                state.list = action.payload
            })
            .addCase(roleSubListAll.pending, (state) => {

                state.subloading = false
            })
            .addCase(roleSubListAll.fulfilled, (state, action) => {
                state.subloading = true
                state.sublist = action.payload
            })
    },
})

export const {
    roleList


} = roleSlice.actions

export default roleSlice.reducer